import { Component, Input } from '@angular/core';
import { NoticeController } from '../../services/notice.controller';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'custom-navbar',
  templateUrl: './custom-navbar.html',
  styleUrls: ['./custom-navbar.scss'],
})

export class CustomNavbar {
  /**
   * 네비게이션바 타이틀.
   */
  @Input('barTitle') title: string = '';

  /**
   * Setting button 표시여부.
   */
  @Input('showSetting') setting: boolean = true;

  /**
   * Setting button 표시여부.
   */
  @Input('showBack') back: boolean = true;

  /**
   * Notice service
   */
  notice: NoticeController;

  constructor(
    private $location: Location,
    notice: NoticeController,
    private $router: Router) {
    this.notice = notice;
  }

  /**
   * 설정 페이지로 이동
   */
  goSetting() {
    this.$router.navigate(['/setting']);
  }

  /**
   * 뒤로가기
   */
  goBack() {
    this.$location.back();
  }
}
